import React from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import {
  qualityAssurancePerformanceColDefs,
  transformQualityAssurancePerformanceData
} from "components/Shared/TimeLogs/Definitions";
import { MSpinner } from "components/Shared";
import MGrid, { ACTION_DOWNLOAD } from "components/Shared/MGrid.tsx";

class QualityAssurancePerformanceCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.getData(
        this.props.data,
        this.props.filterDate
      ),
      dataLastChanged: new Date(),
      currentCaseControlNumber: 0
    };
    this.getData = this.getData.bind(this);
    this.handleGridClick = this.handleGridClick.bind(this);
  }

  componentDidMount() {
    if ((!this.props.data || !this.props.data.length) && this.props.getData && !this.props.isFetchingData) {
      this.props.getData(this.props.internetUserId, this.props.payPeriod.id);
    }
  }

  componentDidUpdate(prevProps) 
  {
    if ((this.props.internetUserId !== prevProps.internetUserId) || (this.props.payPeriod.id !== prevProps.payPeriod.id))
    {
      this.props.getData(this.props.internetUserId, this.props.payPeriod.id);
      this.setState({ currentCaseControlNumber: 0 });
    }

    if (prevProps.data !== this.props.data || prevProps.filterDate !== this.props.filterDate) 
    {
      this.setState({
        data: this.getData(
          this.props.data,
          this.props.filterDate
        ),
        dataLastChanged: new Date()
      });
    }
  }

  getData(data, filterDate) 
  {
    let newData = data;
    if (filterDate) {
      newData = newData.filter(x => x.workDate === filterDate);
    }
    newData = transformQualityAssurancePerformanceData(newData);
    return newData;
  }

  handleGridClick = (row, column) => {
    const rowItem = this.state.data[row];
    switch (column) {
      case "controlnum":
        if (this.props.onControlNumberSelected) {
          this.props.onControlNumberSelected(rowItem.controlIdNumber);
        }
        break;
    }
  };

  render() {
    if (this.props.isFetchingData) {
      return <MSpinner />;
    }
    return (
      <div>
        <Card className={"card-unnested profile-card"}>
          <div
            className="grid-card card-style"
          >
            <MGrid
              columnDefinitions={qualityAssurancePerformanceColDefs}
              onCellButtonClick={this.handleGridClick}
              data={this.state.data}
              dataLastChanged={this.state.dataLastChanged}
              actions={
                [
                  {
                    code: ACTION_DOWNLOAD
                  }
                ]
              }
              isFetchingData={this.props.isFetchingData}
              displayNumOfItemsFound={false}
              headerText={this.props.headerText}
            />
          </div>
        </Card>
      </div>
    );
  }
}
QualityAssurancePerformanceCard.propTypes = {
  data: PropTypes.array.isRequired,
  isFetchingData: PropTypes.bool.isRequired,
  filterDate: PropTypes.string,
  getData: PropTypes.func,
  internetUserId: PropTypes.number,
  payPeriod: PropTypes.object,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  onControlNumberSelected: PropTypes.func,
  headerText: PropTypes.string.isRequired
};
export default QualityAssurancePerformanceCard;
